import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    totalStaked: 'Total {token} staked',
    delegate: 'Delegate',
    liquid: 'Liquid',
    availableToStake: 'Available {token} to stake',
  },
};
